<div class="px-7 pt-4">
  <!-- Toolbar -->
  <div class="flex items-center gap-2.5 py-3.5 flex-wrap">
    <!-- Analysis Dropdown -->
    <mat-form-field *ngIf="labSubmissionDetails?.labManStatusId < 2" class="w-[300px]" appearance="outline">
      <mat-label>Analysis</mat-label>
      <mat-select multiple [(ngModel)]="selectedAnalysisTypes" (click)="setAnalysisDropDown()">
        <mat-option *ngFor="let analysisType of analysisTypes" [value]="analysisType.id">
          {{analysisType.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Add Analysis Button -->
    <button mat-button *ngIf="labSubmissionDetails?.labManStatusId < 2" [disabled]="this.selectedSamples.length === 0 || selectedAnalysisTypes.length === 0" (click)="addAnalysis()"
      class="py-2 px-3.5 !bg-[var(--primary-dark)] rounded-lg text-xs font-semibold !text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all disabled:!bg-[#E6E6E6] disabled:!text-[#C3C3C3]">
      <span class="material-icons text-[16px]">add</span> ADD ANALYSIS
    </button>

    <div class="flex-1"></div>

    <!-- Search -->
    <div class="relative">
      <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
      <input type="text" placeholder="Search analysis..." (keyup)="searchLabAnalysis($event.target.value)"
        class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)] text-[var(--base-text-alt-dark)]">
    </div>
  </div>

  <!-- Table -->
  <div [ngStyle]="{'height': tableHeight}" class="overflow-y-auto overflow-x-hidden mb-5" *ngIf="dataSource?.data">
    <table mat-table [dataSource]="dataSource.data" class="w-full border-collapse">

      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef class="!w-[5%] !py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">
          <mat-checkbox [checked]="dataSource?.data.length > 0 && selectedSamples.length === dataSource?.data.length" [indeterminate]="selectedSamples.length > 0 && dataSource?.data.length !== selectedSamples.length" (change)="selectAllSamples($event)"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element" class="!w-[5%] !py-2 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">
          <mat-checkbox [checked]="selectedSamples.includes(element.id)" (change)="selectSample($event, element.id)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="farm">
        <th mat-header-cell [ngClass]="{'!rounded-tl-lg': labSubmissionDetails?.labManStatusId >= 2}" *matHeaderCellDef class="!w-[10%] !py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Farm</th>
        <td mat-cell *matCellDef="let element" class="!w-[10%] !py-2 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.farm ?? '-'}}</td>
      </ng-container>

      <ng-container matColumnDef="field">
        <th mat-header-cell *matHeaderCellDef class="!w-[10%] !py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Field</th>
        <td mat-cell *matCellDef="let element" class="!w-[10%] !py-2 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.field ?? '-'}}</td>
      </ng-container>

      <ng-container matColumnDef="sample">
        <th mat-header-cell *matHeaderCellDef class="!w-[10%] !py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Sample</th>
        <td mat-cell *matCellDef="let element" class="!w-[10%] !py-2 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">
          {{element?.sample ?? '-'}}
          <span *ngIf="getMergeCount(element.id) > 0" class="inline-block bg-[#1976d2] text-white text-[10px] font-semibold py-0.5 px-1.5 rounded-full ml-1.5 align-middle">{{getMergeCount(element.id)}} samples</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="analysisRequired">
        <th mat-header-cell *matHeaderCellDef class="!w-[65%] !py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Analysis Required</th>
        <td mat-cell *matCellDef="let element" class="!w-[65%] !py-2 !px-3.5 !border-b !border-[var(--app-base)]">
          <div class="flex flex-wrap gap-1.5 items-center">
            <span *ngFor="let analysis of element?.analysisRequired"
              class="inline-flex items-center text-[12px] font-medium text-[var(--primary-dark)] bg-[#EFF8FD] border border-[var(--primary-dark)] py-1.5 px-3 rounded-full">
              {{analysis.labManItemDescription}}
            </span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" style="height: auto; min-height: unset"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="transition-colors !h-auto"
        style="height: auto; min-height: unset"></tr>
    </table>
  </div>

  <!-- Bottom Actions -->
  <div class="h-[54px] w-full flex flex-row justify-between items-center">
    <div *ngIf="labSubmissionDetails?.labManStatusId === 2"></div>
    <button mat-button *ngIf="labSubmissionDetails?.labManStatusId < 2" (click)="clearAnalysis()" [disabled]="selectedSamples.length === 0"
      class="h-12 w-[175px] !text-white !bg-[var(--notification-error)] rounded disabled:!bg-[#E6E6E6] disabled:!text-[#C3C3C3]">CLEAR ANALYSIS</button>

    <mat-paginator style="display:none"
      (page)="onPaginateChange($event)"
      [pageSize]="pageSize"
      [pageIndex]="currentPage"
      [pageSizeOptions]="[5, 10, 20]"
      [showFirstLastButtons]="true"
      [length]="totalElements">
    </mat-paginator>
  </div>
</div>
